import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
  type GroupNode,
  NgDiagramGroupHighlightedDirective,
  type NgDiagramGroupNodeTemplate,
  NgDiagramNodeResizeAdornmentComponent,
  NgDiagramNodeSelectedDirective,
  NgDiagramPortComponent,
} from 'ng-diagram'
import { DdcElementCountComponent } from 'src/app/shared/ddc/ddc-element-count/ddc-element-count.component'
import { DaydicTypesIconNames } from 'src/app/shared/enums/enums'
import { Dictionary } from 'src/app/shared/models/main/dictionary'

export interface GroupNodeData {
  dictionary: Dictionary
}

@Component({
  selector: 'ddc-canvas-node-dictionary',
  imports: [
    NgDiagramPortComponent,
    NgDiagramNodeSelectedDirective,
    NgDiagramGroupHighlightedDirective,
    CommonModule,
    NgDiagramNodeResizeAdornmentComponent,
    MatIcon,
    DdcElementCountComponent,
  ],
  templateUrl: './dictionary-node.component.html',
  styleUrls: ['./dictionary-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ng-diagram-port-hoverable]': 'true',
  },
})
export class CanvasDictionaryNodeComponent implements NgDiagramGroupNodeTemplate<GroupNodeData> {
  node = input.required<GroupNode<GroupNodeData>>()
  title = signal<string>('Dictionary')
  icon = signal<string>(DaydicTypesIconNames.DICTIONARY)
}
